import { createContext, FC, PropsWithChildren, useContext, useRef, useState } from "react";

interface TranslationActivity {
  isTranslating: boolean;
  startTranslation: () => () => void;
}

const TranslationActivityContext = createContext<TranslationActivity>({
  isTranslating: false,
  startTranslation: () => () => undefined,
});

export const TranslationActivityProvider: FC<PropsWithChildren> = ({ children }) => {
  const [pendingCount, setPendingCount] = useState(0);
  const [startTranslation] = useState(() => () => {
    setPendingCount((count) => count + 1);
    const activity = { finished: false };
    return () => {
      if (!activity.finished) {
        activity.finished = true;
        setPendingCount((count) => count - 1);
      }
    };
  });

  return (
    <TranslationActivityContext.Provider value={{ isTranslating: pendingCount > 0, startTranslation }}>
      {children}
    </TranslationActivityContext.Provider>
  );
};

export const useTranslationActivity = () => useContext(TranslationActivityContext);

export const useTranslationActivityRegistration = () => {
  const { startTranslation } = useTranslationActivity();
  const startTranslationRef = useRef(startTranslation);
  return startTranslationRef.current;
};
